import { useState } from "react";
import { fmtDateTime, money } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Empty, PageHead, Spinner, StatusBadge, useFetch } from "@/components/common";
import { CsvButton, PeriodPicker, currentPeriod } from "./salesUi";

const STATUSES = ["", "PENDING", "PAID", "FAILED", "EXPIRED", "CANCELLED", "REFUNDED"];
const methodLabel = (p) => (p.method === "CASH" ? "Cash (legacy)" : `PayMongo${p.paid_via ? ` · ${p.paid_via}` : ""}`);

export default function SalesList() {
  const { user } = useAuth();
  const [period, setPeriod] = useState(currentPeriod());
  const [status, setStatus] = useState("");
  const { data, loading } = useFetch(`/sales/sales?period=${period}${status ? `&status=${status}` : ""}`);
  const rows = (data || []).map((p) => ({
    reference: p.reference, receipt: p.receipt?.number || "", paymongo_payment_id: p.paymongo_payment_id || "", card_serial: p.card_serial,
    package: p.package_name, client: p.purchaser?.name, seller: p.seller_name || p.cashier_name, method: methodLabel(p), amount: p.amount,
    status: p.status, created_at: p.created_at, paid_at: p.paid_at || "",
  }));
  return (
    <div className="space-y-4">
      <PageHead eyebrow="Sales Force" title={user.role === "sales_agent" ? "My sales" : user.role === "sales_manager" ? "Team sales" : "All sales"}
        actions={<div className="flex flex-wrap gap-2"><PeriodPicker value={period} onChange={setPeriod} />
          <select className="field w-40" value={status} onChange={(e) => setStatus(e.target.value)} data-testid="sales-status-filter">{STATUSES.map((s) => <option key={s} value={s}>{s || "All statuses"}</option>)}</select>
          <CsvButton name={`giacare-sales-${period}.csv`} rows={rows} /></div>} />
      {loading && !data ? <Spinner /> : !data?.length ? <Empty title="No sales in this period" /> : (
        <div className="surface overflow-x-auto">
          <table className="data-table" data-testid="sales-table">
            <thead><tr><th>Reference</th><th>Receipt</th><th>Card</th><th>Client</th><th>Seller</th><th>Method</th><th>Amount</th><th>Status</th><th>Date</th></tr></thead>
            <tbody>{data.map((p) => (
              <tr key={p.id} data-testid={`sale-row-${p.reference}`}>
                <td className="font-mono text-xs">{p.reference}</td><td className="font-mono text-xs">{p.receipt?.number || "—"}</td><td className="font-mono text-xs">{p.card_serial}</td>
                <td className="text-xs">{p.purchaser?.name}{p.duplicate_flag && <span className="ml-1 text-amber-600" title="Duplicate active membership">⚑</span>}</td>
                <td className="text-xs">{p.seller_name || p.cashier_name}</td><td className="text-xs">{methodLabel(p)}</td><td className="font-semibold">{money(p.amount)}</td>
                <td><StatusBadge status={p.status} /></td><td className="text-xs">{fmtDateTime(p.paid_at || p.created_at)}</td>
              </tr>
            ))}</tbody>
          </table>
        </div>
      )}
    </div>
  );
}
